export default "__VITE_ASSET__CfGRgFmG__"